import {
    COMPARISON_PRODUCTS_RECEIVE,
    COMPARISON_PRODUCTS_LOADING,
    COMPARISON_PRODUCTS_LOAD_ERROR,
} from '../constants';

const DEFAULT_STATE = {
    products: [],
    loading: false,
};

export const comparisonProducts = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case COMPARISON_PRODUCTS_RECEIVE:
            return {
                ...state,
                ...action.payload,
            };
        case COMPARISON_PRODUCTS_LOADING:
            return {
                ...state,
                ...action.payload,
                errorMessage: action.payload,
                loading: false,
            };
        case COMPARISON_PRODUCTS_LOAD_ERROR:
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
  